var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.pageFrom, inline: "" } },
                [
                  !_vm.miniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "归属客户" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "380px" },
                              attrs: {
                                placeholder: "请选择",
                                size: "small",
                                clearable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "customerId", $$v)
                                },
                                expression: "pageFrom.customerId",
                              },
                            },
                            _vm._l(_vm.customers, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.miniProgramCustomer
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "发放小程序" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "380px" },
                              attrs: {
                                placeholder: "请选择",
                                size: "small",
                                clearable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.appCustomerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "appCustomerId", $$v)
                                },
                                expression: "pageFrom.appCustomerId",
                              },
                            },
                            _vm._l(_vm.appOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "380px" },
                        attrs: {
                          placeholder: "请输入公司名称",
                          size: "small",
                          clearable: "",
                        },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.pageFrom.innerCompanyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "innerCompanyName", $$v)
                          },
                          expression: "pageFrom.innerCompanyName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customers:integral:save"],
                      expression: "['admin:customers:integral:save']",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.add(null)
                    },
                  },
                },
                [_vm._v("新增客户员工信息")]
              ),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:customers:export:fudou:info"],
                          expression: "['admin:customers:export:fudou:info']",
                        },
                      ],
                      attrs: { type: "success", size: "small" },
                      on: { click: _vm.openExportDialog },
                    },
                    [_vm._v("导出福豆使用情况")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "customerId", label: "ID", width: "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerType",
                  label: "客户类型",
                  "min-width": "80",
                  formatter: function (row) {
                    return row.customerType === 1 ? "常规用户" : "小程序用户"
                  },
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "客户名称",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "发放小程序",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "grantIntegral",
                  label: "本年度发放福豆",
                  "min-width": "80",
                  formatter: _vm.formatYuanColumn,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integral",
                  label: "剩余总福豆",
                  "min-width": "80",
                  formatter: _vm.formatYuanColumn,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "max-width": "280",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:customers:business:clientManage:staffManage",
                                ],
                                expression:
                                  "['admin:customers:business:clientManage:staffManage']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.go(scope.row)
                              },
                            },
                          },
                          [_vm._v("员工管理")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:customer:integral:log:save",
                                  "admin:customer:integral:log:recycle",
                                ],
                                expression:
                                  "['admin:customer:integral:log:save','admin:customer:integral:log:recycle']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.addGrant(scope.row, "ADD")
                              },
                            },
                          },
                          [_vm._v("新增发放")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:customer:integral:log:save",
                                  "admin:customer:integral:log:recycle",
                                ],
                                expression:
                                  "['admin:customer:integral:log:save','admin:customer:integral:log:recycle']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.batchGrant(scope.row)
                              },
                            },
                          },
                          [_vm._v("批量发放")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:customers:integral:fudouConvert",
                                ],
                                expression:
                                  "['admin:customers:integral:fudouConvert']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.convertFudou(scope.row)
                              },
                            },
                          },
                          [_vm._v("福豆转移")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:integral:log:recycle"],
                                expression:
                                  "['admin:customer:integral:log:recycle']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.recovery(scope.row)
                              },
                            },
                          },
                          [_vm._v("福豆回收")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customers:integral:update"],
                                expression:
                                  "['admin:customers:integral:update']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.add(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customers:integral:delet"],
                                expression:
                                  "['admin:customers:integral:delet']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.hanldDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "block",
              staticStyle: { "margin-top": "15px", "text-align": "right" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("AddVue", { ref: "AddVueRef", on: { refresh: _vm.getList } }),
          _vm._v(" "),
          _c("AddGrantVue", {
            ref: "AddGrantVueRef",
            attrs: {
              miniProgramCustomer: _vm.miniProgramCustomer,
              companies: _vm.companies,
            },
            on: { refresh: _vm.getList },
          }),
          _vm._v(" "),
          _c("BatchGrantVue", {
            ref: "BatchGrantVueRef",
            attrs: { companies: _vm.companies },
            on: { refresh: _vm.getList },
          }),
          _vm._v(" "),
          _c("RecoveryVue", {
            ref: "RecoveryVueRef",
            attrs: { companies: _vm.companies },
            on: { refresh: _vm.getList },
          }),
          _vm._v(" "),
          _c("ExportDialog", { ref: "ExportDialogRef" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }